import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';

class Brand extends React.Component {
   render() {
      return (
         <div className="Brand" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/brand/" activeStyle={{ color: 'red' }} >Brand</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/brand/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/brand/new" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

Brand.propTypes = {
   children: PropTypes.object
};

export default Brand;



/** WEBPACK FOOTER **
 ** ./src/components/Brand/Brand.js
 **/